// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__26wpz","options":"AnswerScale_options__3fHXJ","selected":"AnswerScale_selected__i_BGO"};